import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import '../static/base.css'
// import './assets/css/app.css'
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.css'
import './components/component'

Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
